<template>
  <div>
    <div class="top">
      <img
        src="../../img/qpxq/return.png"
        alt=""
        class="return"
        @click="gosy()"
      />
      <div class="bt">{{ addrpageflag == true ? "选择地址" : "下单" }}</div>
    </div>
    <div :style="{ display: addrpageflag == true ? 'none' : 'unset' }">
      <div class="list-container">
        <van-form @submit="onSubmit">
          <van-field
            readonly
            clickable
            name="addr"
            v-model="addr"
            rows="1"
            autosize
            label=""
            type="textarea"
            left-icon="location"
            right-icon="arrow"
            placeholder=""
            @click="goaddr()"
          />
          <van-field
            readonly
            clickable
            name="goodsname"
            :value="goodsname"
            label="选择气瓶"
            right-icon="arrow-down"
            placeholder="请选择气瓶"
            @click="showPicker = true"
            :rules="[{ required: true }]"
          />

          <van-popup v-model="showPicker" position="bottom">
            <van-picker
              show-toolbar
              :columns="columns"
              value-key="c_name"
              @confirm="onConfirm"
              @cancel="showPicker = false"
            />
          </van-popup>
          <van-field
            v-model="nnumber"
            type="number"
            name="nnumber"
            label="气瓶数量"
            placeholder="请输入气瓶数量"
            :rules="[{ required: true }]"
          />
          <van-field
            readonly
            clickable
            right-icon="arrow-down"
            name="pstime"
            :value="pstime"
            label="送气时间"
            placeholder="请选择送气时间"
            @click="showPicker1 = true"
            :rules="[{ required: true }]"
          />
          <van-popup v-model="showPicker1" position="bottom">
            <van-datetime-picker
              type="datetime"
              :min-date="minDate"
              @confirm="onConfirm1"
              @cancel="showPicker1 = false"
            />
          </van-popup>

          <van-field
            v-model="remark"
            name="remark"
            rows="1"
            autosize
            label="备注"
            type="textarea"
            placeholder="请输入留言"
          />
          <div class="van-address-list__bottom" style="margin-bottom: 10vw">
            <van-button round block type="info" native-type="submit"
              >提交</van-button
            >
          </div>
        </van-form>
      </div>
    </div>
    <div v-if="addrpageflag">
      <addrpage
        :clientfpid="clientfpid"
        @setclientfpid="setclientfpid"
      ></addrpage>
    </div>
  </div>
</template>

<script>
import {
  getgoodsType,
  getAddrDetailByTel,
  insTOrder,
} from "../../api/ZghApi/ZghAx";
import addrpage from "./addr.vue";
import { Dialog } from "vant";
export default {
  data() {
    return {
      tel: localStorage.getItem("tel"),
      // tel: "15860832301",
      addr: "",
      addrpageflag: false,
      minDate: new Date(),
      // maxDate: new Date(2025, 10, 1),
      goodsname: "",
      goodspid: "",
      pstime: "",
      nnumber: "",
      remark: "",
      columns: [],
      goodstypeList: "",
      showPicker: false,
      showPicker1: false,
      clientfpid: "",
      ruleForm: {},
    };
  },
  components: {
    addrpage,
  },
  created() {
    if(localStorage.getItem("tel")==null || localStorage.getItem("tel")=="" || localStorage.getItem("tel")==undefined){
      this.gosy()
      this.$toast("未查询到用户信息!");
    }
    this.getAddrDetailByTel();
    this.getgoodsType();
  },
  destroyed() {},
  computed: {},
  mounted() {},
  methods: {
    //根据当前时间生成订单号
    getNowDate() {
      let currentDate = new Date();
      let year = currentDate.getFullYear();
      let month = currentDate.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      let date = currentDate.getDate();
      if (date < 10) {
        date = "0" + date;
      }
      let hours = currentDate.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      let minutes = currentDate.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      let seconds = currentDate.getSeconds();
      if (seconds < 10) {
        seconds = "0" + seconds;
      }
      let dateTimeString = year + month + date + hours + minutes + seconds;
      return dateTimeString;
    },
    dateformate(time) {
      var date = time;
      console.log(date);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      var Hours = date.getHours()<10?"0"+date.getHours() : date.getHours();

      var Minutes = date.getMinutes()<10?"0"+date.getMinutes() : date.getMinutes();
      time =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        Hours +
        seperator2 +
        Minutes+
        seperator2+
        "00"

      return time;
    },

    setclientfpid(info) {
      this.addrpageflag = false;
      console.log(info);
      this.addr = info.name + " " + +info.tel + "\n" + info.address;
      this.clientfpid = info.id;
    },
    gosy() {
      if (this.addrpageflag) {
        this.addrpageflag = false;
      } else {
        this.$router.push({ name: "Home" });
      }
    },

    onSubmit(values) {
      console.log("submit", values);

      Dialog.confirm({
        // title: "下单",
        message: "确定下此订单",
      })
        .then(() => {
          const loading = this.$toast.loading({
            message: "订单提交中...",
            duration: 0,
            overlay: true,
            forbidClick: true,
          });
          let orderparams = {
            csource: "3",
            // csysuserid: "admin",
            // csysuserName: "超级管理员",
            // cbranchid: "8734392c0721472ba52c037fe967316b",
            cpaymentTerm: "1",
            dappTime: this.pstime,
            corderNumber: this.getNowDate(),
            cclientid: this.clientfpid,
            ccall: this.tel,
            cremark: this.remark,
            // ccourierid: "2e02e7945c7a410ba2213eb8ae865dbe",
            corderType: 1,
            goodList: [
              {
                curpage: null,
                pagesize: null,
                // goodsType: "重瓶",
                cdel: "0",
                pcid: this.goodsinfo.p_c_id,
                cname: this.goodsinfo.c_name,
                // daddtime: this.goodsinfo.d_addtime,
                ctype: this.goodsinfo.c_type,
                ckindId: this.goodsinfo.c_kind_id,
                ccylinder: this.goodsinfo.c_cylinder,
                nzcprice: this.goodsinfo.n_zcprice,
                nnumber: this.nnumber,
                nmoney: this.goodsinfo.n_zcprice * this.nnumber,
              },
            ],
            nmoney: this.goodsinfo.n_zcprice * this.nnumber,
            cstate: 1,
          };

          insTOrder(orderparams)
            .then((res) => {
              if (res.status == "success") {
                if (res.data.outmap.state == "success") {
                  loading.clear();
                  this.$toast("下单成功!");
                  this.gosy();
                } else {
                  loading.clear();
                  this.$toast(res.data.outmap.msg);
                }
              } else {
                loading.clear();
                this.$toast("下单失败,请联系管理员!");
              }
            })
            .catch((err) => {
              loading.clear();
            });
        })
        .catch(() => {
          loading.clear();
        });
    },
    goaddr() {
      // this.$router.push({ name: "addr" });
      this.addrpageflag = true;
    },
    //计算总价
    changeTotal(row) {
      return row.nzcprice * row.nnumber;
    },
    onConfirm(value) {
      console.log(value);
      this.goodsname = value.c_name;
      this.goodsinfo = value;
      console.log(this.goodsinfo);
      this.showPicker = false;
    },
    onConfirm1(time) {
      this.pstime = this.dateformate(time);
      console.log(time);
      this.showPicker1 = false;
    },
    getAddrDetailByTel() {
      getAddrDetailByTel({ tel: this.tel }).then((res) => {
        if (res.list == null || res.list.length == 0) {
          // this.gosy();
          this.$toast("未查询到地址信息，请联系管理员！");
        } else {
          this.addr =
            res.list[0].name +
            " " +
            res.list[0].tel +
            "\n" +
            res.list[0].address;
          this.clientfpid = res.list[0].id;
          console.log(this.clientfpid);
        }
      });
    },
    getgoodsType() {
      getgoodsType({}).then((res) => {
        // this.columns = res.list;
        if (res.list == null || res.list.length == 0) {
          this.$toast("气瓶类型加载失败，请联系管理员！");
        } else {
          this.columns = res.list;
        }
      });
    },
  },
};
</script>
<style scoped>
.bt {
  position: absolute;
  left: 35vw;
  top: 4vw;
  width: 30vw;
  text-align: center;
  font-size: 4vw;
  font-weight: 600;
}
.zt1 {
  font-size: 4vw;
  font-weight: 500;
}
.list-container {
  padding: 1vw 3.6% 4.6%;
  height: 80%;
}
.van-button--round {
  border-radius: 10px;
}
.top {
  height: 12vw;
  width: 100vw;
  position: relative;
  background-color: rgb(245, 247, 251);
}
.return {
  width: 5vw;
  margin-top: 1.8vw;
  margin-left: 4vw;
}
</style>



// WEBPACK FOOTER //
// src/views/Home/xd.vue